import React from "react";
import { useTranslation } from "react-i18next";

const KEY = "trubeaute.consent.analytics";

export default function PrivacyConsent() {
  const { t } = useTranslation();
  const [choice, setChoice] = React.useState(() => {
    try { return localStorage.getItem(KEY); } catch (_) { return null; }
  });
  const [open, setOpen] = React.useState(() => choice === null);

  const save = (value) => {
    try { localStorage.setItem(KEY, value); } catch (_) { /* storage unavailable */ }
    setChoice(value);
    setOpen(false);
    // Trackers are loaded only during document bootstrap. Reloading guarantees
    // that accepting starts them and rejecting removes any previously loaded tag.
    window.location.reload();
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-3 left-3 z-[9998] rounded-full border border-[#D8C9C4] bg-white/95 px-3 py-1.5 text-xs text-[#5D4050] shadow-sm"
      >
        {t("privacyConsent.choices")}
      </button>
    );
  }

  return (
    <section
      role="dialog"
      aria-label={t("privacyConsent.choices")}
      className="fixed inset-x-3 bottom-3 z-[9999] mx-auto max-w-2xl rounded-2xl border border-[#D8C9C4] bg-white p-5 text-left shadow-2xl"
    >
      <h2 className="font-serif text-xl text-[#2C2123]">{t("privacyConsent.title")}</h2>
      <p className="mt-2 text-sm leading-6 text-[#5D4050]">
        {t("privacyConsent.body")}
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" onClick={() => save("denied")} className="rounded-full border border-[#9B6A6C] px-4 py-2 text-sm text-[#5D4050]">
          {t("privacyConsent.reject")}
        </button>
        <button type="button" onClick={() => save("granted")} className="rounded-full bg-[#5D4050] px-4 py-2 text-sm text-white">
          {t("privacyConsent.accept")}
        </button>
        {choice !== null && (
          <button type="button" onClick={() => setOpen(false)} className="px-3 py-2 text-sm text-[#8A7D82]">
            {t("privacyConsent.cancel")}
          </button>
        )}
      </div>
      <a href="/privacy" className="mt-3 inline-block text-xs underline text-[#5D4050]">
        {t("privacyConsent.policy")}
      </a>
    </section>
  );
}
